<template>
  <section>
    <PublicationsHeader />
    <PublicationsSearch />
    <PublicationsIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Publications',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['publication-index'] || {}
    }
  }
}
</script>
